import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from 'src/app/common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { PatientDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { PatientDto } from 'src/app/shared/models/patient/patient-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class PatientWorkItem extends WorkItem<PatientDto> {
  unitOfWork: IUnitOfWork;

  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'PatientWorkItem';
  }
  get database(): string {
    return PatientDB;
  }

  public async afterUpdate(patientFromDb: PatientDto, patientToSync: PatientDto): Promise<PatientDto> {
    delete patientToSync.validToDate;

    return patientFromDb;
  }
}
